export default __webpack_public_path__ + "static/media/MarketingBrew.300fb006.png";